export const HERO_BANNER_TEST_ID = {
   prevSlideButton: 'prevSlideButton',
   currentBannerDiv: 'currentBannerDiv',
   nextSlideButton: 'nextSlideButton',
   slider: 'slider',
};
